module.exports = __webpack_public_path__ + "img/phoneicon.a753c00d.png";